import { ChainId } from '@pancakeswap/sdk'

export const verifyBscNetwork = (chainId: number) => {
  return chainId === ChainId.MANTLE || chainId === ChainId.MANTLE_TESTNET
}
